/* eslint-disable no-throw-literal */
import { useState } from 'react';
import useForm from 'hooks/useForm';
import useCustomer from 'hooks/useCustomer';

const requiredFields = ['email', 'password'];

export default function useLogin() {
  const {
    setCustomerAccessToken,
    handleLogin: login,
    customerAccessToken,
    customer,
    cartData,
    loading,
    handleLogout
  } = useCustomer({ checkoutOnly: true, fetchShipping: true });
  const form = useForm({}, requiredFields);
  const [errors, setErrors] = useState('');
  const handleLogin = async e => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setErrors(null);
    try {
      const { data: loginData } = await login(form.state.inputs);
      if (
        loginData?.customerAccessTokenCreate?.userErrors &&
        loginData.customerAccessTokenCreate.userErrors[0]
      ) {
        throw {
          shopifyError: true,
          error: loginData.customerAccessTokenCreate.userErrors[0]
        };
      }
      const customerAccessToken =
        loginData?.customerAccessTokenCreate?.customerAccessToken?.accessToken;
      await setCustomerAccessToken({
        variables: {
          customerAccessToken
        }
      });
      return customerAccessToken;
    } catch (e) {
      console.log(e);
      if (e?.error?.message === 'Unidentified customer') {
        setErrors(['Incorrect email or password']);
      }
      if (e?.createError) {
        setErrors([e.createError.replace('GraphQL error:', '').trim()]);
      }
      throw e;
    }
  };
  return {
    form,
    errors,
    handleLogin,
    customerAccessToken,
    customer,
    cartData,
    loading,
    handleLogout
  };
}
